import sha1 from "sha1";

const pending = new Map();
const confirmedKeys = new Set();
const serialize = (value) => JSON.stringify(value, (_key, item) => {
  if (typeof File !== "undefined" && item instanceof File) return { name: item.name, size: item.size, lastModified: item.lastModified, type: item.type };
  if (item && Object.getPrototypeOf(item) === Object.prototype) return Object.fromEntries(Object.keys(item).sort().map((key) => [key, item[key]]));
  return item;
});

// A retry of an interrupted checkout keeps its key, including across a reload.
// Session storage contains only a digest and opaque key, never payment/address/auth data.
export const checkoutAttempt = (buyerIdentity, body) => {
  const stableBody = JSON.parse(serialize(body), (key, value) => ['submittedAt', 'Delivered', 'paymentIntent', 'amountTotal', 'expectedShippingCents', 'expectedAmountCents', 'shipping_amount_local'].includes(key) ? undefined : value);
  const storageKey = `elakay:checkout:${sha1(`${buyerIdentity || ""}:${serialize(stableBody)}`)}`;
  let key = pending.get(storageKey);
  if (!key) {
    try { key = window.sessionStorage.getItem(storageKey); } catch { /* storage may be disabled */ }
  }
  if (!key) key = window.crypto?.randomUUID?.() || `checkout_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
  pending.set(storageKey, key);
  try { window.sessionStorage.setItem(storageKey, key); } catch { /* in-memory retry remains available */ }
  let confirmed = confirmedKeys.has(key);
  try { confirmed = confirmed || window.sessionStorage.getItem(`${storageKey}:created`) === key; } catch { /* optional storage */ }
  return {
    key,
    confirmed,
    markCreated: () => {
      confirmedKeys.add(key);
      try { window.sessionStorage.setItem(`${storageKey}:created`, key); } catch { /* optional persistence */ }
    },
    complete: () => {
      if (pending.get(storageKey) === key) pending.delete(storageKey);
      confirmedKeys.delete(key);
      try { if (window.sessionStorage.getItem(storageKey) === key) window.sessionStorage.removeItem(storageKey); } catch { /* optional persistence */ }
      try { if (window.sessionStorage.getItem(`${storageKey}:created`) === key) window.sessionStorage.removeItem(`${storageKey}:created`); } catch { /* optional persistence */ }
    },
  };
};
